import React from 'react';
import './Toggle.css';

function Toggle(Props) {
    return (
        <>
             <div className="toggle_block">
            <p className="toggle_option"> {Props.topic}</p>
          
          </div>
        </>
    )
}

export default Toggle
